namespace Nobox.Nobox {
    export interface AddCustomFieldForm {
        field: FieldEditor;
        inputType: InputTypeEditor;
        required: Serenity.BooleanEditor;
        label: Serenity.StringEditor;
        placeHolder: Serenity.StringEditor;
        selectOpsiElm: Serenity.Extensions.StaticTextBlock;
        selectOpsi: Serenity.StringEditor;
        DefValue: Serenity.StringEditor;
        QDef: Serenity.IntegerEditor;
        QMin: Serenity.IntegerEditor;
        QMax: Serenity.IntegerEditor;
    }

    export class AddCustomFieldForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.AddCustomField';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AddCustomFieldForm.init)  {
                AddCustomFieldForm.init = true;

                var s = Serenity;
                var w0 = FieldEditor;
                var w1 = InputTypeEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.StringEditor;
                var w4 = s.Extensions.StaticTextBlock;
                var w5 = s.IntegerEditor;

                Q.initFormType(AddCustomFieldForm, [
                    'field', w0,
                    'inputType', w1,
                    'required', w2,
                    'label', w3,
                    'placeHolder', w3,
                    'selectOpsiElm', w4,
                    'selectOpsi', w3,
                    'DefValue', w3,
                    'QDef', w5,
                    'QMin', w5,
                    'QMax', w5
                ]);
            }
        }
    }
}
